import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Header from "./components/header";
import Footer from "./components/footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import RouteEffects from "./components/RouteEffects";
import Home from "./pages/home";
import Acomodacoes from "./pages/acomodacoes";
import Termos from "./pages/termos";
import Estrutura from "./pages/estrutura";
import EstruturaDetalhe from "./pages/estrutura/EstruturaDetalhe";
import Localizacao from "./pages/localizacao";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true,
      offset: 72,
      easing: "ease-out-cubic",
      delay: 0,
    });
  }, []);

  return (
    <Router>
      <RouteEffects />
      <Header />
      <main className="site-main">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/acomodações" element={<Acomodacoes />} />
          <Route path="/termos" element={<Termos />} />
          <Route path="/estrutura" element={<Estrutura />} />
          <Route path="/estrutura/:slug" element={<EstruturaDetalhe />} />
          <Route path="/localizacao" element={<Localizacao />} />
        </Routes>
      </main>
      <Footer />
      <WhatsAppFloat />
    </Router>
  );
}

export default App;
